import styled from 'styled-components';

export const BulletList = styled.div`
  margin-left: 8px;
`;